import { IExtractedField } from 'types/db/ExtractedProForma';
import { CardResolver } from '../../layout/cardTypes';
import { DetailsMetricId } from '../../layout/metrics';
import { buildFieldMap, extractedItem, hasDataWithPrefix, notExtractedItem } from './cells';

export const extractedDetailsResolver = (fields: IExtractedField[]): CardResolver<DetailsMetricId> => {
    const fieldMap = buildFieldMap(fields);

    return {
        hasData: () => hasDataWithPrefix(fieldMap, 'details.'),

        address: extractedItem(fieldMap, 'details.address'),
        coordinates: notExtractedItem(),
        landArea: extractedItem(fieldMap, 'details.land_area'),
        far: extractedItem(fieldMap, 'details.floor_area_ratio'),
        grossBuildableArea: extractedItem(fieldMap, 'details.gross_buildable_area'),
        buildings: extractedItem(fieldMap, 'details.buildings'),
        stories: extractedItem(fieldMap, 'details.stories'),
        units: extractedItem(fieldMap, 'details.units'),
        grossBuiltSf: extractedItem(fieldMap, 'details.gross_built_sf'),
        netRentableArea: extractedItem(fieldMap, 'details.net_rentable_area'),
        efficiencyRatio: extractedItem(fieldMap, 'details.building_efficiency_ratio'),
        parkingSpaces: extractedItem(fieldMap, 'details.parking_spaces'),
        parkingRatio: extractedItem(fieldMap, 'details.parking_ratio'),
        description: notExtractedItem(),
    };
};
